/**
 * Módulo frontend CRONJOBS — rutas y metadatos del menú.
 * La UI y las traducciones viven bajo esta carpeta.
 */
import isAdminRoleGuard from "@/pages/Auth/guards/is-admin-role.guard";

export const CRONJOBS_MODULE_NAME = "cronjobs_module";

/** Enlace del sidebar (Ajustes / admin) */
export const cronjobsModuleMenuItem = {
  name: "Cronjobs",
  icon: "clock",
  path: "/cron-jobs",
};

export const cronjobsModuleRoutes = [
  {
    path: "cron-jobs",
    name: "CronJobsSettings",
    components: { default: () => import("./pages/CronJobsSettings.vue") },
    meta: {
      title: "CRONJOBS",
      requiresAuth: true,
      requiresModule: CRONJOBS_MODULE_NAME,
    },
    beforeEnter: isAdminRoleGuard,
  },
];

export default {
  moduleName: CRONJOBS_MODULE_NAME,
  routes: cronjobsModuleRoutes,
  menuItem: cronjobsModuleMenuItem,
};
